import { RouteRecordRaw } from 'vue-router';

const staticRoutes: Array<RouteRecordRaw> = [
  {
    path: 'static',
    component: () => import('@/app/_static/example-component.vue'),
    name: 'app.static',
  },
];

export default staticRoutes;
